module.exports = [
 {
  "start": 41,
  "end": 3166,
  "text": "The installation Das Zimmer is a constellation "
 },
 {
  "start": 3250,
  "end": 5917,
  "text": "to choose and watch several single channels "
 },
 {
  "start": 6000,
  "end": 8000,
  "text": "or extracts of installations "
 },
 {
  "start": 8125,
  "end": 11708,
  "text": "For me Das Zimmer has numerous connotations. "
 },
 {
  "start": 12041,
  "end": 15041,
  "text": "On the one hand, reality vanishes and shrinks "
 },
 {
  "start": 15083,
  "end": 16917,
  "text": "while you’re watching TV. "
 },
 {
  "start": 17291,
  "end": 19417,
  "text": "So by switching the dimensions, "
 },
 {
  "start": 19500,
  "end": 21208,
  "text": "I inverted things. "
 },
 {
  "start": 21291,
  "end": 24250,
  "text": "I impose physical reality on the viewer. "
 },
 {
  "start": 24500,
  "end": 26166,
  "text": "The other meaning has to do with "
 },
 {
  "start": 26208,
  "end": 29333,
  "text": "how I see the museum as a public living room… "
 },
 {
  "start": 29542,
  "end": 30959,
  "text": "I want the viewers to have "
 },
 {
  "start": 31083,
  "end": 32959,
  "text": "the feeling of being at home.”"
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room3/audio2/03_2MCA Das Zimmer.js